/**
 * Typically a MUI avatar will have 1 or 2 characters inside.
 */
export const getAvatarText = (name: string, numLetters = 1) => {
  return name
    .split(/\s+/)
    .slice(0, numLetters)
    .map((str) => {
      const filtered = str.replace(/[^A-Za-z0-9]/g, '');
      return filtered.length ? filtered[0].toUpperCase() : '';
    })
    .join('');
};
